module.exports = __webpack_public_path__ + "img/citrixsynergy.1f187220.jpg";